<script>
import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";
import { mapActions } from "vuex";
// import appConfig from "@/app.config";
import axios from 'axios';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    notifications: {
      get() {
        return this.$store.state.notifications;
      },
      set(value) {
        this.$parent.$emit("ReadNotification", value);
      },
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  components: { simplebar },
  data() {
    return {
      layoutColor: "white",
      userName: "",
    };
  },
  methods: {
    switchLayout(layoutColor) {
      let that = this;
      that.$swal
        .fire({
          text: "This page will reload, Please save all your data",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#34c38f",
          confirmButtonColor: "#f46a6a",
          confirmButtonText: "Ok, reload",
          cancelButtonText: "No, wait",
        })
        .then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem("layoutColor", layoutColor);
            location.reload();
          }
        });
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    ...mapActions({
      signOut: "auth/logout",
    }),
    async logout() {
      // await axios.post(appConfig.logout).then(({ data }) => {
        // console.log(data)
        this.signOut();
        this.$router.push({ name: "login" });
      // });
    },

    async markAsRead(notification) {
      let that = this;
      if (notification.seen == 0) {
        await axios
          .post("notifications/read/" + notification.id)
          .then(function (response) {
            console.log(response.data)
            that.getNotifications();
          });
      }
    },

    checkIfAnyNotReededMSG(data) {
      let flag = false;
      for (let index = 0; index < data.length; index++) {
        if (data[index].seen == 0) {
          flag = true;
          break;
        }
      }
      return flag;
    },

    async getNotifications() {
      let that = this;
      await axios.get("notifications").then(function (response) {
        let newData = response.data;
        let firstN = newData.slice(0, 10);

        that.$store.dispatch("notifications/addNotification", firstN);
        that.$store.dispatch("notifications/setFetched", true);
        if (that.checkIfAnyNotReededMSG(firstN)) {
          that.$store.dispatch("notifications/unreadedMSG"); // markNotSeen
        } else {
          that.$store.dispatch("notifications/allMSGsReaded"); // markAllSeen
        }
      });
    },

    handleRouteClick(notification) {
      if (notification.section_name != this.currentRouteName) {
        this.$router.push({ name: notification.section_name });
        this.markAsRead(notification);
      } else {
        this.markAsRead(notification);
        this.$refs.notifications_dropdown.hide(true);
      }
    },
  },
  created() {
    this.layoutColor = localStorage.getItem("layoutColor");
    this.userName = this.$store.state.auth.user.name;
  },
  mounted() {
    // let that = this;
    // if (!that.$store.state.notifications.fetched) {
    //   window.Echo.channel(
    //     appConfig.title + "_" + "notification." + that.$store.state.auth.user.id
    //   ).notification((notification) => {
    //     that.getNotifications();
    //     const soundData = {
    //       soundurl: "https://soundbible.com/mp3/Pling-KevanGC-1485374730.mp3",
    //     };
    //     const audio = new Audio(soundData.soundurl);
    //     audio.play();
    //   });
    //   that.getNotifications();
    // }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                :src="require('@/assets/images/logo-sm-dark.png').default"
                height="22"
              />
            </span>
            <span class="logo-lg">
              <img
                :src="require('@/assets/images/logo-dark.png').default"
                alt
                height="35"
              />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                :src="require('@/assets/images/logo-sm-light.png').default"
                alt
                height="22"
              />
            </span>
            <span class="logo-lg">
              <img
                :src="require('@/assets/images/logo-light.png').default"
                alt
                height="35"
              />
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 d-lg-none header-item"
          data-toggle="collapse"
          @click="toggleMenu"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>
      </div>

      <div class="d-flex">
        <div class="dropdown d-lg-inline-block ml-1" v-if="layoutColor == 'dark'">
          <button
            type="button"
            title="Bright Mode"
            class="btn header-item noti-icon waves-effect"
            @click="switchLayout('white')"
          >
            <i class="ri-sun-line"></i>
          </button>
        </div>

        <div class="dropdown d-lg-inline-block ml-1" v-if="layoutColor != 'dark'">
          <button
            title="Dark Mode"
            type="button"
            class="btn header-item noti-icon waves-effect"
            @click="switchLayout('dark')"
          >
            <i class="ri-moon-fill"></i>
          </button>
        </div>

        <div class="dropdown d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="initFullScreen"
          >
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
          ref="notifications_dropdown"
        >
          <template v-slot:button-content>
            <i class="ri-notification-3-line"></i>
            <span v-if="notifications.notseen" class="noti-dot"></span>
          </template>
          <div class="p-3 border-bottom">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Notifications</h6>
              </div>
              <div class="col-auto">
                <router-link :to="{ name: 'Notifications' }" class="small">
                  View All
                </router-link>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a
              @click="handleRouteClick(notification)"
              v-for="notification in notifications.notifications"
              :key="notification.id"
              class="text-reset notification-item"
            >
              <div
                class="media border-bottom"
                :class="{ not_readed: notification.seen == 0 }"
                @click="markAsRead(notification)"
              >
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ notification.notification_message }}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ notification.date }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <span class="d-xl-inline-block ml-1">{{ userName }}</span>
            <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <button type="button" class="dropdown-item text-danger" @click="logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            Logout
          </button>
        </b-dropdown>

        <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle waves-effect toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="ri-settings-2-line toggle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.notification-item .media {
  cursor: pointer;
}

.notification-item .not_readed {
  background-color: #ffeaea;
}

.dark-layout .notification-item .not_readed {
  background-color: #620206;
}
</style>
